import { render, staticRenderFns } from "./EntityCardList.vue?vue&type=template&id=195c29a1&scoped=true"
import script from "./EntityCardList.vue?vue&type=script&lang=js"
export * from "./EntityCardList.vue?vue&type=script&lang=js"
import style0 from "./EntityCardList.vue?vue&type=style&index=0&id=195c29a1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "195c29a1",
  null
  
)

export default component.exports